module.exports = __webpack_public_path__ + "static/Add-To-Favorites-510692f5078a934befc97afd8c25ef51.png";